import { resolveTokenLogo } from 'app/config/logos';
import { isNotNullNorUndefined } from '@silo/utils';
import { ChecksumAddress, getProtocolInstanceChainId, ProtocolInstance } from '@silo/types';
import { placeholderUnknownLogoURL } from '@silo/ui';

/**
 * Returns an array of logo URLs that a given token's logo could be
 * retrieved from. Array is ordered in the order of location preference.
 * Meaning that URLs that appear earlier in the array are preferred over
 * URLs that appear later.
 */
export const getTokenLogoURLs = (
  address: ChecksumAddress | undefined,
  protocolInstance: ProtocolInstance
): string[] => {
  if (!address) return [placeholderUnknownLogoURL];

  const chainId = getProtocolInstanceChainId(protocolInstance);
  const maybeURLs: (string | null)[] = [resolveTokenLogo(chainId, address), placeholderUnknownLogoURL];

  return maybeURLs.filter(isNotNullNorUndefined);
};
